import { call, put, select } from 'redux-saga/effects';

import { IWorkoutResponse } from 'api/components/PersonalPlan/types';
import api from 'api';

import { getWorkoutSuccess } from 'store/personalPlan/actions';

import { IWorkoutExtended } from 'types/personalPlan';

import { selectCurrentDay, selectPlanDays } from '../selectors';

export function* getWorkout() {
    try {
        const currentDay: number = yield select(selectCurrentDay);
        const days: IWorkoutExtended[] = yield select(selectPlanDays);

        const { workout_id, type, day_number } = days[currentDay - 1];

        const workout: IWorkoutResponse = yield call(api.personalPlan.getWorkout, {
            workout_id,
            workout_type: type,
            day_number,
        });

        yield put(getWorkoutSuccess(workout));
    } catch (error: any) {
        console.error('Get personal plan error: ', error.message);
    }
}
